const doc = [({"da":({"js":({"components":({"surveys":({"surveys":({"copy_step_button":({"copy_step":"Kopiér step", "the_step_was_copied":"Steppet blev kopieret."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;